import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { StripeProduct } from 'interfaces/stripe-product'
import { Price } from 'interfaces/price'

export interface ProductBundle {
  base_product: StripeProduct
  addon_products: StripeProduct[]
  additional_products: StripeProduct[]
  prices: { [productId: string]: Price[] }
}

const fetchProductBundle = async (
  productId: string
): Promise<ProductBundle> => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v1/stripe/product_bundle?product_id=${productId}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const data = await response.json()
  return data
}

export const useProductBundle = (
  productId: string,
  enabled: boolean = true
) => {
  return useQuery(
    ['product-bundle', productId],
    () => fetchProductBundle(productId),
    {
      enabled: enabled && !!productId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  )
}
